import React from 'react';
import { connect } from 'react-redux';
import { translate } from '../../../base/i18n/functions';
import Dialog from '../../../base/ui/components/web/Dialog';
import AbstractKickRemoteParticipantDialog from '../AbstractKickRemoteParticipantDialog';
import { getParticipantDisplayName } from '../../../base/participants';
import { Trans } from 'react-i18next';
/**
 * Dialog to confirm a remote participant kick action.
 */
class KickRemoteParticipantDialog extends AbstractKickRemoteParticipantDialog {
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const displayName = getParticipantDisplayName(APP.store.getState(), this.props.participantID);
        return (React.createElement(Dialog, { ok: { translationKey: 'dialog.kickParticipantButton' }, onSubmit: this._onSubmit, titleKey: 'dialog.kickParticipantTitle' },
            React.createElement("div", null,
                React.createElement(Trans, { i18nKey: "dialog.kickParticipantDialog", values: { displayName: displayName } }))));
    }
}
export default translate(connect()(KickRemoteParticipantDialog));
